/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type PreviewEquipmentBulkEditViewRequestBody = {
  /**
   * Display template to preview
   */
  displayTemplate: string;
};

/** @internal */
export type PreviewEquipmentBulkEditViewRequestBody$Outbound = {
  display_template: string;
};

/** @internal */
export const PreviewEquipmentBulkEditViewRequestBody$outboundSchema: z.ZodType<
  PreviewEquipmentBulkEditViewRequestBody$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentBulkEditViewRequestBody
> = z.object({
  displayTemplate: z.string(),
}).transform((v) => {
  return remap$(v, {
    displayTemplate: "display_template",
  });
});

export function previewEquipmentBulkEditViewRequestBodyToJSON(
  previewEquipmentBulkEditViewRequestBody:
    PreviewEquipmentBulkEditViewRequestBody,
): string {
  return JSON.stringify(
    PreviewEquipmentBulkEditViewRequestBody$outboundSchema.parse(
      previewEquipmentBulkEditViewRequestBody,
    ),
  );
}
